import { render, staticRenderFns } from "./customerService.vue?vue&type=template&id=a9ff2640&lang=pug"
import script from "./customerService.vue?vue&type=script&lang=js"
export * from "./customerService.vue?vue&type=script&lang=js"
import style0 from "./customerService.vue?vue&type=style&index=0&id=a9ff2640&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports